module.exports = __webpack_public_path__ + "static/media/new_profile_icon.97719fc6.svg";